<template>
    <div>
        <div class="main_slider">
            <swiper
                class="swiper swiper-container-slider-autod"
                :options="swiperOption"
                ref="swiperHome"
                @slideChange="onSlide">
                <swiper-slide v-for="(bannerHero, index) in banners" :key="index">
                    <a :href="bannerHero.redirect_to ? bannerHero.redirect_to : '#'" @click="saveClick(bannerHero.id)">
                        <div
                            class="home__hero container bg-top bg-cover bg-no-repeat flex flex-column justify-content-center
                            xl:justify-content-center align-items-center pt-50 sm:pt-30 xl:pt-42 lg:mb-20"
                            :style="'background-image: url(' + bannerImg[index] + ');'"
                        >
                            <div class="tx-center">
                                <div v-if="bannerHero.texts_hidden == 0">
                                    <h2 class="tx-18 sm:tx-18 md:tx-30 xl:tx-42 tx-white">{{ bannerHero.home_text_1 }}</h2>
                                    <h4 class="tx-15 sm:tx-15 md:tx-25 xl:tx-32 tx-white" style="font-weight: 400;">
                                        {{ bannerHero.home_text_2 }}
                                    </h4>

                                </div>
        <!--                         <div id="slider_buttons_container">
                                    <a href="/nuevos" class="btn btn--green-ad p-4 mb-2" id="button-buy">
                                        <img src="/assets/images/car-icon.svg" alt="">
                                        <span class="block">Comprar auto nuevo</span>
                                    </a>
                                    <div class="flex justify-content-between">
                                        <a href="/filtros" class="btn btn--white-ad btn-sell btn--nav-ad p-4">
                                            <span class="block">Comprar seminuevo de agencia</span>
                                        </a>
                                        <a :href="subastaloUrl" target="_blank" class="btn btn--white-ad btn-sell btn--nav-ad p-4">
                                            <span class="block">Vender mi auto</span>
                                        </a>
                                    </div>
                                </div> -->
                            </div>
                            <p class="ff-montserrat-bold uppercase tx-center tx-20 sm:tx-15 md:tx-30 xl:tx-40  tx-white mb-3 wow slideInUp"
                                data-wow-delay="1.7s" style="display: none">
                                <span
                                    class="tx-white"
                                    :class="'typed-animated' + index"
                                >
                                </span>
                            </p>
                            <div class="overflow-hidden mb-0 lg:mb-18" v-if="bannerHero.content"></div>
                        </div>
                    </a>
                </swiper-slide>
            </swiper>
        </div>
        <section class="bottom-slider-icons">
            <div class="flex">
                <a href="/catalogo" class="btn btn--green-ad py-4 px-10 tx-18 lg:tx-22 uppercase">
                    <h3 class="text-icon-alignt">
                        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="14" viewBox="0 0 512 512">
                            <path d="M135.2 117.4L109.1 192H402.9l-26.1-74.6C372.3 104.6 360.2 96 346.6 96H165.4c-13.6 0-25.7 8.6-30.2 21.4zM39.6 196.8L74.8 96.3C88.3 57.8 124.6 32 165.4 32H346.6c40.8 0 77.1 25.8 90.6 64.3l35.2 100.5c23.2 9.6 39.6 32.5 39.6 59.2V400v48c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V400H96v48c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V400 256c0-26.7 16.4-49.6 39.6-59.2zM128 288a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm288 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"/></svg>
                        Comprar Seminuevo
                    </h3>
                </a>
                <a href="/nuevos/catalogo" class="btn bg-white-ad tx-black py-4 px-10 tx-18 lg:tx-22">
                    <h3 class="text-icon-alignt">
                        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="14" viewBox="0 0 13 14" fill="none">
<path d="M5.73333 5.73333L4.66667 9.33333L3.6 5.73333L0 4.66667L3.6 3.6L4.66667 0L5.73333 3.6L9.33333 4.66667L5.73333 5.73333ZM10 8.8L12.6667 7.33333L11.2 10L12.6667 12.6667L10 11.2L7.33333 12.6667L8.8 10L7.33333 7.33333L10 8.8ZM5.33333 10L4.2 12L5.33333 14L3.33333 12.8667L1.33333 14L2.46667 12L1.33333 10L3.33333 11.1333L5.33333 10Z" fill="black"/>
</svg>
                        Nuevos de agencia
                    </h3>
                </a>
            </div>
        </section>
        <partners-component></partners-component>
<!--         <div id="slider_content" class="flex">
            <div class="tx-center">
                <h2 class="tx-18 sm:tx-18 md:tx-30 xl:tx-42 tx-white">Las agencias sí hacen los trámites por ti</h2>
                <h4 class="tx-15 sm:tx-15 md:tx-25 xl:tx-32 tx-white" style="font-weight: 400;">
                    Aquí puedes ver los autos disponibles o ver <strong>quién te da más</strong> por el tuyo
                </h4>
                <p data-wow-delay="2.5s" class="uppercase tx-center sm:tx-10 tx-10 md:tx-14 opacity-70 transition-200 tracking-loose wow slideInDown"
                    style="visibility: visible; animation-delay: 2.5s; animation-name: slideInDown; color: #fff">¡Hagamos &nbsp;
                    <span style="text-decoration:underline #dbfe54">Deal</span>!</p>
                <div id="slider_buttons_container" class="flex flex-direction-row">
                    <a href="/nuevos" class="btn btn--green-ad p-4 m-2" id="button-buy">
                        <img src="/assets/images/car-icon.svg" alt="" class="mr-2">
                        <span class="block">Comprar auto nuevo</span>
                    </a>
                    <a href="/filtros" class="btn btn--white-ad btn-sell btn--nav-ad p-4 m-2">
                        <span class="block">Comprar seminuevo de agencia</span>
                    </a>
                    <a :href="subastaloUrl" target="_blank" class="btn btn--white-ad btn-sell btn--nav-ad p-4 m-2">
                        <span class="block">Vender mi auto</span>
                    </a>
                </div>
            </div>
        </div> -->
    </div>
</template>
<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import StepperBuyCar from './StepperBuyCar.vue';
import metadataService from '../../../../services/metadataService';
export default {
    components: {
        Swiper,
        SwiperSlide,
        StepperBuyCar,
    },
    data: () => ({
        banners: [],
        filters: {
            brands: null,
            models: null,
            states: null,
            dealerships: null,
            prices: {
                from: null,
                to: null
            },
            zip_code: null
        },
        subastaloUrl: '#',
        currentSlide: 0,
        bannerImg:[],
        swiperOption: {
            centeredSlides: true,
            autoplay: {
                delay: 9000,
                disableOnInteraction: false
            }
        },
        showModalUser: false,
        swiperOptionTop: {
                lazy: true,
                slidesPerView: 3,
                spaceBetween: 8,
                loop: true,
                // loopFillGroupWithBlank: true,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                },
                breakpoints: {
                    540: {
                        slidesPerView: 1
                    },
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 12
                    },
                    1280: {
                        slidesPerView: 3,
                        spaceBetween: 12
                    }
                }
            }
    }),
    created() {
        metadataService.createMetaDescription('Autos Seminuevos, autos nuevos, vende tu auto, distribuidores, servicio, reparación | AutoDeal',
         'Encuentra los mejores autos seminuevos, nuevos, consulta mas de 2000 anuncios de autos certificados. Además vende tu auto, consulta distribuidores y donde reparar tu auto');
    },
    methods: {
        onSlide() {
            this.currentSlide = this.$refs.swiperHome.$swiper.activeIndex;
        },
        openModalUser () {
            this.showModalUser = true;
        },
        closeModal () {
            this.showModalUser = !this.showModalUser;
        },
        async getBanners() {
            const smallScreens = ['sm']
            const stateId = (this.$cookies.get('stateUser') && this.$cookies.get('stateUser') != 33) ? this.$cookies.get('stateUser') : 0
            const { data } = await axios.get(`${process.env.MIX_API_SUBASTALO_URL}/api/marketplace/state/${stateId}/banners/home`)
            this.banners = smallScreens.includes(this.$mq) || this.$ ? data.mobile : data.desktop
        },
        async saveClick(id) {
            try {
                await axios.post(`${process.env.MIX_API_SUBASTALO_URL}/api/marketplace/save-click`, {
                    banner_id: id,
                });
            } catch (error) {
                console.log(error);
            }
        }
    },
    async mounted() {
        this.subastaloUrl = process.env.MIX_SUBASTALO_URL

        await this.getBanners()

        for (let index = 0; index < this.banners.length; index++) {
            let img = this.banners[index].url;

            this.bannerImg.push(img)

            var banner = this.banners[index].title;

            new Typed(".typed-animated" + index, {
                strings: [banner],
                typeSpeed: 50,
                cursorChar: ' '
            });
        }
    }
};
</script>

<style lang="scss">
/**
 * swiper class native
 * overwrite the display type of the car mark options at the top of the car cards
 *
 */
.swiper-container {
    max-height: 100vh;
    margin-left: auto;
    margin-right: auto;
    position: relative;
    overflow: hidden;
    list-style: none;
    padding: 0;
    z-index: 0;
}

.swal2-select-override {
    font-size: 1rem;
	background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2IiBoZWlnaHQ9IjEwIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGZpbGw9IiM5RUEwQTUiIGQ9Ik0zLjA0NSAwbDIuOTM0IDIuOTM0TDAgMy4wNDUgMy4wNDUgMHptLS4xMDIgOS45OThMMCA3LjA1NWw1Ljk5Ny0uMTEyLTMuMDU0IDMuMDU1eiIvPjwvc3ZnPg==") !important;
	background-position: calc(100% - 7px) 50%;
	background-repeat: no-repeat;
	background-size: 7px;
	overflow: hidden;
	padding-right: 20px;
	cursor: pointer;
}

.swiper-wrapper {
    // height: 50vh;

    @media screen and (min-width: 1024px) {
        height: calc(100vh - (266px + 74px));
    }
}

.home__hero {
    height: 50vh;
    margin: 0px;
    @media screen and (min-width: 1024px) {
        height: calc(100vh - (266px + 74px));
    }
}

</style>

<style lang="scss" scoped>

.main_slider_modified {
    // max-height: 75vh;

    @media screen and (min-width: 1366px) {
        max-height: 100%;
    }
}
#filters_headers_container {
    color: #fff;
    >h2 {
        font-family: 'montserrat-bold';
        font-size: calc(2vw + 10px);
        @media only screen and (max-width: 540px) {
            font-size: calc(2.3vw + 10px);
        }
    }
    >p {
        font-size: calc(1vw + 10px);
        @media only screen and (max-width: 540px) {
            font-size: calc(1.4vw + 10px);
        }
    }
}

#slider_buttons_container {
    font-family: 'montserrat-bold';
    z-index: 9999;
    font-size: 1rem;
    justify-content: center;
    // width: 65%;
    // max-width: 800px;
    width: 678px;
    flex-wrap: wrap;
    margin: auto;

    & > div {
        flex-direction: column;
        width: 100%;

        & > a {
            width: 100%;
            &:first-child {
                margin-bottom: 0.5rem;
                @media screen and (min-width: 1024px) {
                    margin-bottom: 0;
                }
            }
            @media screen and (min-width: 1024px) {
                width: 49%;
            }
        }

        @media screen and (min-width: 1024px) {
            flex-direction: row;
        }
    }

    @media only screen and (max-width: 767px) {
        flex-direction: column;
        height: 242px;
        align-items: center;
        width: 100%;
        flex-wrap: nowrap;
    }

    @media only screen and (max-width: 420px) {
        height: 25vh;
        font-size: calc(1vw + 9px);
    }

/*     a {
        width: 330px;
        @media screen and (min-width: 420px) and (max-width: 519px) {
            width: 90%;
        }
        @media screen and (min-width: 520px) and (max-width: 767px) {
            width: 70%;
        }
        @media only screen and (max-width: 420px) {
            width: 98%;
            max-height: 43.8px;
        }
    } */
}

#button-buy {
    width: 100% !important;
/*     width: 678px !important;

    @media screen and (min-width: 420px) and (max-width: 519px) {
        width: 90% !important;
        }
    @media screen and (min-width: 520px) and (max-width: 767px) {
        width: 70% !important;
    }
    @media screen and (min-width: 767px) and (max-width: 1092px) {
        width: 330px !important;
    }
    @media only screen and (max-width: 420px) {
        width: 98% !important;
        max-height: 43.8px;
    } */
}


.bottom-slider-icons {
    width: 100%;
    background-color: #000;
    font-weight: 600;
    position: relative;
    z-index: 2;
    height: 266px;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    @media screen and (min-width: 1024px) {
        width: 100%;
    }
}
.text-icon-alignt {
    display: flex;
    align-items: center;
    gap: 10px;
}

/* .bottom-slider-icons-mobile {
    height: 50vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    > a {
        font-size: 0.8rem;
    }
} */

.bottom-slider-icons-mobile {
    width: 100%;
    background-color: #000;
    // padding-bottom: 20px;
    font-weight: 600;
    position: relative;
    z-index: 2;
    // margin-top: -200px;
    // padding-bottom: 20px;
    bottom: 0;
    // position: absolute;

    height: 50vh;
    @media screen and (min-width: 1024px) {
        height: calc(100vh - (220px + 74px));
    }

    @media screen and (min-width: 1024px) {
        display: none;
        // margin-top: -260px;
    }

    > a {
        > h3 {
            font-size: 0.6rem;
        }
    }

    > div > div > div > div {
        color: #fff;
        position: relative;
        // display: grid;
        max-width: 33.33333%;
        padding-top: 5px;
        // grid-template-columns: repeat(auto-fit, 200px);
        // gap: 10px;
        // justify-content: center;
        // justify-items: center;
        text-align: center;

        > a {
            text-transform: uppercase;
            // border-bottom: 1.5px solid #DBFE54;
            text-align: center;
            margin: 25px 0;

            > img {
                margin-bottom: 20px;
                width: 50px;
            }

            > h3 {
                font-size: 0.6rem;
                margin-bottom: 0;
            }
        }
    }

    > .bottom-slider-icons-mobile-content {
        transform: translateY(calc(50% + 31.5px));

        > .swiper-container {
            margin-bottom: 15px;
        }
    }

    .swiper-button-prev, .swiper-button-next {
        top: 50%;
        transform: translateY(-50%);
    }
}

.bottom-slider-icons > div {
    color: #fff;
    position: relative;
    width: 100%;
    gap: 10px;
    justify-content: space-around;
    justify-items: center;
    flex-direction: column;
    > a {
        text-transform: uppercase;
        text-align: center;
        margin: 15px 10px;
        width: 94%;
        @media screen and (min-width: 920px) {
            margin: 25px 0;
            width: auto;
        }
        > img {
            margin-bottom: 20px;
            width: 40%;
        }

        > h3 {
            margin-bottom: 0;
            font-size: 16px;
        }
    }
    @media screen and (min-width: 920px) {
        width: 60%;
        flex-direction: row;
    }
    @media screen and (min-width: 1600px) {
        margin: 0 auto;
        flex-direction: row;
        width: 50%;
    }
}


.bottom-slider-icons > a {
    text-transform: none;
    display: block;
    margin: 10px auto;
    font-size: 16px;
}
</style>

